/* MR.VIK — rotating discount card.
   Crossfades one offer at a time. Auto-advance stops on hover, on any manual
   dot press, and while the tab is hidden. With a single offer nothing runs at
   all — the markup renders no dots and data-autoplay is false. */
(function () {
  'use strict';

  function init(root) {
    var slides = root.querySelectorAll('[data-off-slide]');
    if (slides.length < 2) return;

    var dots = root.querySelectorAll('[data-off-dot]');
    var i = 0;
    var timer = null;
    var auto = root.getAttribute('data-autoplay') === 'true';
    var every = parseInt(root.getAttribute('data-interval'), 10) || 3000;

    function show(n) {
      i = (n + slides.length) % slides.length;
      for (var s = 0; s < slides.length; s++) slides[s].classList.toggle('is-on', s === i);
      for (var d = 0; d < dots.length; d++) {
        dots[d].classList.toggle('is-on', d === i);
        dots[d].setAttribute('aria-selected', d === i ? 'true' : 'false');
      }
    }
    function start() { if (auto && !timer) timer = setInterval(function () { show(i + 1); }, every); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    for (var d = 0; d < dots.length; d++) {
      (function (n) {
        dots[n].addEventListener('click', function (e) {
          e.preventDefault();
          // a deliberate press hands control over for good
          auto = false; stop(); show(n);
        });
      })(d);
    }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });

    show(0);
    start();
  }

  function boot() {
    var all = document.querySelectorAll('[data-mv-offers]');
    for (var n = 0; n < all.length; n++) init(all[n]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
